import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';

@Component({
  selector: 'app-transaction-creation-modal',
  templateUrl: './transaction-creation-modal.component.html',
  styleUrls: ['./transaction-creation-modal.component.scss'],
})
export class TransactionCreationModalComponent {
  private entryForm: FormGroup;
  public action: string;
  public headerMessage: string;
  public today;
  public tomorrow;
  public cancel = false;
  public transaction: any = {};

  constructor(
    public dialogRef: MatDialogRef<TransactionCreationModalComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService
  ) {
    this.today = new Date();
    this.tomorrow = new Date(new Date().getTime() + 13888000000);
    dialogRef.disableClose = true;
    this.action = this.data.action;
    this.headerMessage = this.data.msg;
    this.entryForm = formBuilder.group({
      type: new FormControl(
        data.amount ? (data.amount < 0 ? 'Expense' : 'Income') : '',
        Validators.compose([Validators.required, Validators.maxLength(32)])
      ),
      description: new FormControl(
        data.description ? data.description : '',
        Validators.compose([Validators.required, Validators.maxLength(32)])
      ),
      category: new FormControl(
        data.category ? data.category : '',
        Validators.compose([Validators.required, Validators.maxLength(32)])
      ),
      amount: new FormControl(
        data.amount ? data.amount : '',
        Validators.compose([Validators.required, Validators.maxLength(32)])
      ),
      date: new FormControl(
        data.date ? new Date(data.date) : '',
        Validators.compose([Validators.required, Validators.maxLength(32)])
      ),
    });
  }
  get f() {
    return this.entryForm.controls;
  }

  public onSubmit() {
    if (!this.cancel) this.doAction();
  }

  doAction() {
    if (this.entryForm.valid) {
      this.manageDataInput();
      this.dialogRef.close({ event: this.action, data: this.transaction });
    }
  }

  closeDialog() {
    this.cancel = true;
    this.dialogRef.close({ event: 'Cancel' });
  }

  private manageDataInput() {
    const date = new Date(this.entryForm.value.date);
    this.transaction.date = date.getTime();
    const amount = Math.abs(this.entryForm.value.amount);
    this.transaction.amount =
      this.entryForm.value.type === 'Expense' ? amount * -1 : amount;
    this.transaction.id = this.data.id ? this.data.id : new Date().getTime();
    this.transaction.description = this.entryForm.value.description;
    this.transaction.category = this.entryForm.value.category;
    this.transaction.owner = this.authenticationService.currentUserId;
    this.action = this.data.action;
  }
}
